module.exports = __webpack_public_path__ + "img/stampa-bollettini.79e9956e.jpg";